import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    AddCompetitorToLead as AddCompetitorToLeadMutation,
    AddCompetitorToLeadVariables,
    LeadCompetitorAddInput,
} from 'nutshell-graphql-types';

import ADD_COMPETITOR_TO_LEAD from '../mutations/add-competitor-to-lead.graphql';

export const useAddCompetitorToLead = (): {
    addCompetitorToLead: (arg1: LeadCompetitorAddInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [addCompetitorToLead, {loading, error}] = useMutation<
        AddCompetitorToLeadMutation,
        AddCompetitorToLeadVariables
    >(ADD_COMPETITOR_TO_LEAD);

    return {
        addCompetitorToLead: (input: LeadCompetitorAddInput) =>
            addCompetitorToLead({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
